// @flow

export const autoCompleteEnum = {
  off: "chrome-off",
  email: "email",
  tel: "tel"
};

export type autoCompleteType = $Values<typeof autoCompleteEnum>;
